import { render, staticRenderFns } from "./TheHeaderDropdownAccount.vue?vue&type=template&id=2b75d1f8&scoped=true&"
import script from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownAccount.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownAccount.vue?vue&type=style&index=0&id=2b75d1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b75d1f8",
  null
  
)

export default component.exports